function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Button from "segments/desktop/core-components/button/button";
import Bullets from "segments/desktop/core-components/bullets/bullets";
import classnames from "classnames";
import Colors from "styles/colors";
import { withSegmentsData } from "contexts/segment-context";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { withRouter } from "next/router";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getDynamicSubTitleConfigForPath, getDynamicTitleConfigForPath } from "client/services/cluster-config-service/cluster-config-service";
import Icons from "segments/desktop/core-components/icons/icons";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH } from "constants/vp-sizes";
import DefaultProps from "./default-props";
import { StyledFullParagraph } from "./full-paragraph.scss";
import AssetComponent from "/components/core/asset/asset-component";
export const PARAGRAPH_HORIZONTAL_PADDING = 32;
export const PARAGRAPH_HORIZONTAL_PADDING_STRING = `${PARAGRAPH_HORIZONTAL_PADDING}px`;
class FullParagraph extends PureComponent {
    getComponentInlineStyles() {
        const { textColor, paragraphVerticalColoredLineColor } = this.props;
        const verticalLeftLineColor = Colors[paragraphVerticalColoredLineColor];
        let inlineStyles = {
            textAlign: this.getTextAlignBasedOnDeviceType(),
            color: textColor
        };
        if (paragraphVerticalColoredLineColor) {
            inlineStyles = _object_spread_props(_object_spread({}, inlineStyles), {
                borderImage: `linear-gradient(to bottom, ${verticalLeftLineColor}, transparent) 0 0 0 1`
            });
        }
        return inlineStyles;
    }
    render() {
        const { body, bodyColor, buttonConfig, bulletsConfig, textSize, titleSize, titleColor, isFirstSegment, withDynamicParagraphTitle, withDynamicParagraphSubtitle, title, titleClassName, clusterConfig, activePagePath, titleIcon, iconsConfig, paragraphVerticalColoredLineColor, textAlign, textWidth, removeBulletsMobileMarginTop, openLiveBoardExperience, renderButton, buttonWidth, assetUnderParagraph } = this.props;
        const _ref = assetUnderParagraph || {}, { marginBetweenParagraphAndAsset } = _ref, restAssetprops = _object_without_properties(_ref, [
            "marginBetweenParagraphAndAsset"
        ]);
        const inlineComponentStyles = this.getComponentInlineStyles();
        const titleToUse = withDynamicParagraphTitle && getDynamicTitleConfigForPath(clusterConfig, activePagePath) || title;
        const subTitleToUse = withDynamicParagraphSubtitle && getDynamicSubTitleConfigForPath(clusterConfig, activePagePath) || body;
        const alignItemsClassName = `align-items-${textAlign}`;
        return /*#__PURE__*/ _jsxs(StyledFullParagraph, {
            className: classnames("full-paragraph", {
                "with-left-line": paragraphVerticalColoredLineColor,
                [alignItemsClassName]: textAlign
            }),
            style: inlineComponentStyles,
            buttonWidth: buttonWidth,
            children: [
                this.renderTopic(),
                titleToUse && /*#__PURE__*/ _jsx("div", {
                    className: "title-wrapper",
                    style: this.getTitleStyle(),
                    children: /*#__PURE__*/ _jsx(Title, {
                        title: titleToUse,
                        titleSize: titleSize,
                        titleColor: titleColor,
                        titleIcon: titleIcon,
                        isFirstSegment: isFirstSegment,
                        titleClassName: titleClassName
                    })
                }),
                subTitleToUse && /*#__PURE__*/ _jsx("div", {
                    className: "paragraph-body-wrapper",
                    children: /*#__PURE__*/ _jsx(Paragraph, {
                        body: subTitleToUse,
                        bodyColor: bodyColor,
                        textSize: textSize,
                        isFirstSegment: isFirstSegment,
                        textWidth: textWidth
                    })
                }),
                bulletsConfig && /*#__PURE__*/ _jsx("div", {
                    className: classnames("bullets-wrapper", this.getTextAlignBasedOnDeviceType(), {
                        "no-mobile-margin": removeBulletsMobileMarginTop
                    }),
                    children: /*#__PURE__*/ _jsx(Bullets, _object_spread({}, bulletsConfig))
                }),
                iconsConfig && /*#__PURE__*/ _jsx("div", {
                    className: classnames("icons-wrapper", this.getTextAlignBasedOnDeviceType()),
                    children: /*#__PURE__*/ _jsx(Icons, _object_spread({}, iconsConfig))
                }),
                buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ _jsx("div", {
                    className: classnames("button-wrapper", this.getTextAlignBasedOnDeviceType()),
                    style: this.getButtonWrapperStyle(),
                    children: renderButton && renderButton() || /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig, openLiveBoardExperience ? {
                        onClick: openLiveBoardExperience
                    } : {}))
                }),
                assetUnderParagraph && /*#__PURE__*/ _jsx("div", {
                    className: "paragraph-asset-wrapper",
                    style: {
                        marginTop: marginBetweenParagraphAndAsset
                    },
                    children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, restAssetprops))
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getTextAlignBasedOnDeviceType", ()=>{
            const { isMobileBrowser, textAlign, mobileTextAlign } = this.props;
            if (!isMobileBrowser) return textAlign;
            return mobileTextAlign || textAlign;
        });
        _define_property(this, "getTitleStyle", ()=>{
            const { titleMinWidth, titleWidth, topicText, spaceFromParagraph } = this.props;
            let style = {
                maxWidth: `min(${titleWidth}, ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH})`
            };
            if (!topicText) {
                style = _object_spread_props(_object_spread({}, style), {
                    marginTop: 0
                });
            }
            if (spaceFromParagraph) {
                style = _object_spread_props(_object_spread({}, style), {
                    marginBottom: spaceFromParagraph
                });
            }
            if (this.getTextAlignBasedOnDeviceType() === "center") {
                const minWidth = `min(${titleMinWidth}, ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH}, calc(100vw - ${PARAGRAPH_HORIZONTAL_PADDING_STRING}))`;
                style = _object_spread_props(_object_spread({}, style), {
                    minWidth
                });
            }
            return style;
        });
        _define_property(this, "getButtonWrapperStyle", ()=>{
            const { buttonTopMargin } = this.props;
            if (!buttonTopMargin) return null;
            return {
                marginTop: buttonTopMargin
            };
        });
        _define_property(this, "renderTopicImage", (removeMargin)=>{
            const { topic, topicBottomMargin } = this.props;
            const { image } = topic;
            if ((image === null || image === void 0 ? void 0 : image.src) || (image === null || image === void 0 ? void 0 : image.href)) {
                return /*#__PURE__*/ _jsx("div", {
                    className: classnames("full-paragraph-topic-image-wrapper", this.getTextAlignBasedOnDeviceType()),
                    style: {
                        marginBottom: !removeMargin && topicBottomMargin
                    },
                    children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, _object_spread_props(_object_spread({}, image), {
                        pictureComponentHeight: image === null || image === void 0 ? void 0 : image.height
                    }))
                });
            }
            return null;
        });
        _define_property(this, "renderTopicText", (removeMargin)=>{
            const { topic, topicBottomMargin } = this.props;
            const { text: topicText, color, borderColor } = topic;
            if (topicText) {
                const borderStyles = borderColor && {
                    border: `1px solid ${Colors[borderColor]}`,
                    borderRadius: "8px",
                    padding: "6px 12px"
                };
                return /*#__PURE__*/ _jsx("div", {
                    className: "full-paragraph-topic",
                    style: _object_spread({
                        color: Colors[color],
                        marginBottom: !removeMargin && topicBottomMargin
                    }, borderStyles),
                    children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                        text: topicText
                    })
                });
            }
            return null;
        });
        _define_property(this, "renderTopic", ()=>{
            const { topic, topicBottomMargin } = this.props;
            const { allowTextAndImage, gap } = topic;
            if (allowTextAndImage) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "full-paragraph-topic-image-and-text-wrapper",
                    style: {
                        gap,
                        marginBottom: topicBottomMargin
                    },
                    children: [
                        this.renderTopicImage(true),
                        this.renderTopicText(true)
                    ]
                });
            }
            return this.renderTopicImage() || this.renderTopicText();
        });
    }
}
FullParagraph.defaultProps = DefaultProps;
export default withSegmentsData(withRouter(withGenericConfig(FullParagraph)));
